import slugifyLib from "slugify";

export const SLUG_MIN_LENGTH = 6;
export const SLUG_MAX_LENGTH = 50;

interface SlugifyOptions {
  /** Trim leading/trailing replacement chars (default: true) */
  trim?: boolean;
}

/**
 * Convert a string to a URL-safe slug.
 */
export function slugify(text: string, options: SlugifyOptions = {}): string {
  const { trim = true } = options;
  return slugifyLib(text, { lower: true, strict: true, trim }).slice(0, SLUG_MAX_LENGTH);
}
